import React from 'react';
import ReactDOM from 'react-dom';

import SiteSearch from '../../react/Navigation/SiteSearch';

export default class {

	constructor(context) {
		this.context = context;
		this.init();
	}

	init() {
		this.initReact();
	}

	initReact() {
		const {
			contactLink,
			contactText,
			searchInactivityTimeout,
		} = this.context.dataset;

		ReactDOM.render(
			<SiteSearch
				contactLink={contactLink}
				contactText={contactText}
				inactivityTimeout={searchInactivityTimeout}
			/>,
			this.context
		);
	}
}
